import React, { useEffect, useState } from "react";
import Player from "../../../components/reusable/player/Player";
import { Typography, Button, IconButton } from "@mui/material";
import useModal from "../../../hooks/useModel";
import { useNavigate, useLocation } from "react-router-dom";

import { IoChevronBack } from "react-icons/io5";

import { useFetchDetailDataQuery } from "../../../api/homepageApi";
import { useParams } from "react-router";
import { useNavbar } from "../../../context/NavBarContext";
import MusicDetailLoading from "../../../components/skeletonLoading/detailLoading/MusicDetailLoading";

import { useMusic } from "../../../context/MusicContext";
/** Error Pages **/
import { NotFound } from "../../error/NotFound_404";

// const MemoizedPlayer = React.memo(Player);
const MusicDetail = () => {
  const location = useLocation();
  const { state } = location;
  const type = state?.type || "";
  const normalClick = state?.normal || false;

  const [rerenderKey, setRerenderKey] = useState(0);
  const musicContext = useMusic();
  const [loading, setLoading] = useState(false); // New state for loading
  const [isInitialMount, setIsInitialMount] = useState(true);
  const [options, setOptions] = useState({
    url: "",
    body: {},
  });

  const Navbar = useNavbar();
  const { id } = useParams();

  const navigate = useNavigate();
  const [Modal, openModal, closeModal, onCloseCustom] = useModal();

  const { data, error, isLoading, isFetching } = useFetchDetailDataQuery(
    options,
    {
      skip: isInitialMount,
    }
  );

  useEffect(() => {
    if (musicContext.skip && musicContext.song.id && musicContext.isCLickSkip) {
      // Navigate to the new URL only when the skip state is true
      navigate(`/music/detail/songs/${musicContext.song.id}`, {
        replace: true,
      });
      // Reset the skip state to prevent repeated navigation
      musicContext.setIsClickSkip(false);
    }
  }, [
    musicContext.skip,
    musicContext.song.id,
    navigate,
    musicContext.isCLickSkip,
  ]);



  const handleSubscribeConfirmed = () => {
    navigate("/account/purchase_subscription");
    closeModal();
  };

  const handleCanceled = () => {
    console.log("handleCanceled called");
    navigate(-1);
    closeModal();
  };


  const modalBody = (
    <div className="text-center leading-5">
      <Typography
        variant="body1"
        component="div"
        lineHeight={2}
        fontWeight="bold"
      >
        အကန့်သတ်မရှိ
      </Typography>
      <Typography
        variant="body1"
        component="div"
        lineHeight={2}
        fontWeight="bold"
      >
        အသံစာအုပ်နှင့်သီချင်းများစွာ
      </Typography>
      <Typography
        variant="body1"
        component="div"
        lineHeight={2}
        fontWeight="bold"
      >
        နားဆင်ဖို့ အခုပဲ ဝန်ဆောင်မှုရယူလိုက်ပါ
      </Typography>
    </div>
  );

  const modalActions = (
    <div className="flex items-center justify-center w-full mb-3">
      <Button
        size="small"
        variant="contained"
        disableRippl
        onClick={handleSubscribeConfirmed}
        sx={{
          marginTop: "20px",
          paddingTop: "5px",
          paddingBottom: "5px",
          paddingRight: "50px",
          paddingLeft: "50px",
          borderTopLeftRadius: "10px",
          borderBottomLeftRadius: "10px",
          borderTopRightRadius: "10px",
          borderBottomRightRadius: "10px",
          backgroundColor: "#facc15",
          color: "black",
          fontWeight: "600",
          "&:hover": {
            backgroundColor: "#eab308",
            borderColor: "#eab308",
            boxShadow: "none",
          },
          "&:active": {
            boxShadow: "none",
            backgroundColor: "#facc15",
            borderColor: "#ca8a04",
          },
        }}
      >
        ဝန်ဆောင်မှုရယူမည်
      </Button>
    </div>
  );

  useEffect(() => {
    const updateOptions = () => {
      setOptions(() => ({
        url: `/music/song/detail`,
        body: {
          song_id: id,
        },
      }));
    };

    updateOptions();
    setIsInitialMount(false);
    // Navbar.setLogoPlace(data?.result.title);
    Navbar.setTogglePlace(<IoChevronBack fontSize="20" />);

    if (data?.result.audio_url === "") {
      // musicContext.pauseAudio();
      openModal();

    }
  }, [data, id]);

  useEffect(() => {
    if (isFetching) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [isFetching]);

  if (isLoading) {
    return <MusicDetailLoading />;
  }

  if (error) {
    return <NotFound error={error} />;
  }

  return (
    <>
      {data ? (
        <div className="mt-3" key={rerenderKey}>
          <div className="rounded-lg h-64">
            <img
              key={data.result.id}
              src={data.result.image}
              alt="image"
              className="rounded-lg w-full h-full object-cover"
            />
          </div>
          <div className="mt-4 block">
            <Typography variant="h6" className="tracking-wider">
              {data.result.title}
            </Typography>
            <Typography className="text-white text-opacity-50">
              {data.result.artist}
            </Typography>
          </div>
        </div>
      ) : (
        ""
      )}
      {data?.result.audio_url ? (
        <Player data={data.result} type={type} />
      ) : (
        //  <Player data={data.result} />
        ""
      )}

      {/* Modal */}
      {handleCanceled && (
        <Modal
          title=""
          body={modalBody}
          actions={modalActions}
          isCloseCustom={true}
          onCloseCustom={handleCanceled}
        />
      )}
    </>
  );
};

export default MusicDetail;
